export default __webpack_public_path__ + "static/letitys-b4a268762ca8a5460b9d85d402776cc3.jpg";